// Libs
import clsx from "clsx";
import React from "react";

// Utils
import { MarketingActionVariantEnum } from "src/utils/variants";

// Components
import { Icon, type IconProps, type Icons } from "src/design-system/molecules/icons";

export const MARKETING_ACTION_ICONS_MAP: Record<
    MarketingActionVariantEnum & "special-cofunded",
    Icons
> = {
    [MarketingActionVariantEnum.Offer]: "offer-classic",
    [MarketingActionVariantEnum.SponsoredAd]: "sponsored-ad-classic",
    [MarketingActionVariantEnum.AutoRule]: "auto-rule",
    [MarketingActionVariantEnum.OptimizedAutoRule]: "auto-rule",
    [MarketingActionVariantEnum.Duo]: "duo",
    [MarketingActionVariantEnum.Special]: "offer-special",
    [MarketingActionVariantEnum.SmartScheduler]: "offer-smart-scheduler",
    [MarketingActionVariantEnum.CoFunded]: "non-flynt",
    ["special-cofunded"]: "offer-special-cofunded",
};

export interface MarketingActionVariantIconsProps extends IconProps {
    /**
     * Additional className
     */
    className?: string;
    /**
     * Variants of component;
     */
    variants: MarketingActionVariantEnum[];
}

export const MarketingActionVariantIcons = React.forwardRef<
    HTMLDivElement,
    MarketingActionVariantIconsProps
>(function MarketingActionVariantIcons(
    { className: classNameProp, variants, ...otherProps },
    ref
): JSX.Element {
    const className = clsx("fl-c-marketing-action-icon", classNameProp);

    const iconList: Icons[] = [];

    const marketingActionTypeVariant = variants.find((v) =>
        [MarketingActionVariantEnum.Offer, MarketingActionVariantEnum.SponsoredAd].includes(v)
    );

    if (
        (variants.includes(MarketingActionVariantEnum.Classic) ||
            variants.includes(MarketingActionVariantEnum.SponsoredAd)) &&
        !variants.includes(MarketingActionVariantEnum.Duo) &&
        !variants.includes(MarketingActionVariantEnum.AutoRule) &&
        !variants.includes(MarketingActionVariantEnum.OptimizedAutoRule) &&
        !variants.includes(MarketingActionVariantEnum.Special) &&
        !variants.includes(MarketingActionVariantEnum.SmartScheduler) &&
        !variants.includes(MarketingActionVariantEnum.CoFunded)
    ) {
        iconList.push(MARKETING_ACTION_ICONS_MAP[marketingActionTypeVariant]);
    } else if (
        variants.includes(MarketingActionVariantEnum.Special) &&
        variants.includes(MarketingActionVariantEnum.CoFunded)
    ) {
        iconList.push(
            MARKETING_ACTION_ICONS_MAP[MarketingActionVariantEnum.CoFunded],
            MARKETING_ACTION_ICONS_MAP[MarketingActionVariantEnum.Special]
        );
    } else {
        const otherVariant = variants.find((v) => v !== marketingActionTypeVariant);
        iconList.push(MARKETING_ACTION_ICONS_MAP[otherVariant]);
    }

    return (
        <div className="fl-c-marketing-action-variant-icons" ref={ref}>
            {iconList.map((e, index) => {
                return (
                    <Icon
                        key={`icon_variant_${index}`}
                        className={className}
                        icon={e}
                        size="s"
                        {...otherProps}
                    />
                );
            })}
        </div>
    );
});
